import { useCallback, useRef } from 'react';
import { type GridRef } from '@adv-frontend/grid';

export const useGridPageClick = (onPageChange: (page: number) => void) => {
    const gridRef: GridRef = useRef(null);

    const handlerPageClick = useCallback(
        (page: number) => {
            if (gridRef.current) {
                gridRef.current?.scrollToOffset(0);
            }

            onPageChange(page);
        },
        [onPageChange]
    );

    return { gridRef, handlerPageClick };
};
